/** Factory the app uses. OWNER: HUD-UI-AUDIO agent (keep the name). */
import type { Hud } from '../types';
import { Bo2Hud } from './hud';

export function createHud(): Hud {
  return new Bo2Hud();
}
